<app-loader *ngIf="isLoading else addToCartTemplate"></app-loader>

<ng-template #addToCartTemplate>
  <div>
    <div class="side-bar-header bg-primary">
      <div class="event-place">
        {{ eventView?.auditorium?.name }}
      </div>
      <div class="text-bold secondary fs-20">
        {{ eventView?.name }}
      </div>
      <datetime-offset [date]="eventView?.startDate">
        {{ eventView?.startDate | timezone }}
      </datetime-offset>
    </div>

    <app-callout *ngIf="errorCallout" [callout]="errorCallout" class="m-2"></app-callout>

    <ng-container *ngIf="!errorCallout">
      <app-callout *ngIf="!eventView?.customersCountryIsEnabled" [callout]="customersCountryIsDisabledCallout" class="m-2"></app-callout>
      <app-callout *ngIf="showOnlineWarningMessage$ | async" [callout]="onlineEventCallout" class="m-2"></app-callout>
      <app-callout *ngIf="eventView?.isFree; else ticketCards" [callout]="freeEventCallout" class="m-2"></app-callout>

      <ng-template #ticketCards>
        <div *ngIf="eventView?.ticketValidity" class="ticket-card ticket-time-restriction">
          <div class="fs-13 px-2 pt-2">{{ 'stemx_label_ticket_time_restriction_warning' | translate :
            ((eventView.ticketValidityDays ? ('stemx_label_ticket_time_restriction_warning_dayss' | translate : eventView.ticketValidityDays) : '') +
            (eventView.ticketValidityDays && eventView.ticketValidityHours ? ' ' + ('label_and' | translate) + ' ' : '') +
            (eventView.ticketValidityHours ? ('stemx_label_ticket_time_restriction_warning_hours' | translate : eventView.ticketValidityHours) : '')) }}
          </div>
        </div>
        <div *ngFor="let priceCategory of eventView?.priceCategories">
          <div class="ticket-card">
            <!-- TICKET INFO -->
            <div>
              <div class="ticket-name fs-15 px-2 pt-2">{{ priceCategory.name }}</div>
              <div class="ticket-group fs-13 px-2">{{ priceCategory.group }}</div>
              <div class="text-bold bold p-2">
                {{ priceCategory.price | money: priceCategory.currency }}
              </div>
            </div>

            <!-- SOLD OUT -->
            <div class="text-error" *ngIf="!(priceCategory.availableCapacity || (priceCategory.availableCapacity === null) || priceCategory.amount)">{{ 'interface_lang_sold_out' | translate }}</div>

            <!-- DROPDOWN -->
            <div class="form-group" [class.loading]="isDisabled === priceCategory.id" *ngIf="priceCategory.availableCapacity || (priceCategory.availableCapacity === null) || priceCategory.amount">
              <select class="form-select" (change)="updateCart($event.target.value, priceCategory)" [disabled]="isDisabled || !eventView?.customersCountryIsEnabled" [ngModel]="priceCategory.amount">
                <option *ngFor="let option of getDropdownOptions(priceCategory.availableCapacity, priceCategory.amount); trackBy: trackByFn">{{ option }}</option>
              </select>
            </div>
          </div>

          <!-- ERROR MESSAGE -->
          <div class="text-error p-2" *ngIf="requestError === priceCategory.id">{{ requestErrorMessage | translate }}</div>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <div class="side-bar-footer" *ngIf="!errorCallout">
    <a routerLink="/cart" class="btn btn-primary" [class.disabled]="isDisabled || (disableNextButton$ | async) !== true" [class.loading]="isDisabled" id="go_to_cart_button">{{ 'label_go_to_cart' | translate }}</a>
  </div>
</ng-template>
